import React from "react";
import FixedStationsSystemGraphs from "./FixedStationsSystemGraphs";
import { useParams, useLocation } from "react-router-dom";

const FixedStationsPage = () => {
  const { displayId } = useParams();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const interval = queryParams.get("interval");

  const CONFIG = {
    displayId,
    intervals: [
      { key: "15min", label: "15 Min" },
      { key: "daily", label: "Daily" },
    ],
    defaultInterval: interval ?? "15min",
  };

  return <FixedStationsSystemGraphs config={CONFIG} />;
};

export default FixedStationsPage;
